import type { ComponentType } from "react";
import { ApertureOnlySetting } from "./settings/aperture-only-setting";
import { ToastTester } from "./toast-tester/toast-tester";

export type DevtoolsSectionDefinition = {
  /** Stable id, used to remember which sections are expanded. */
  id: string;
  title: string;
  description: string;
  Content: ComponentType;
};

/**
 * Every tool shown in the Local Devtools panel, in display order. To add a
 * tool, build it as a self-contained component (in its own folder when it
 * needs more than one file) and add an entry here.
 */
export const DEVTOOLS_SECTIONS: readonly DevtoolsSectionDefinition[] = [
  {
    Content: ApertureOnlySetting,
    description: "Local environment toggles.",
    id: "settings",
    title: "Settings"
  },
  {
    Content: ToastTester,
    description: "Raise any toast variant, with or without actions.",
    id: "toast-tester",
    title: "Toast tester"
  }
];
